<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="openDialog()">{{ $t('新增') }}</el-button>

    </template>

    <template #search-form>
      <el-form-item :label="$t('标识')">
        <el-input :placeholder="$t('标识')" v-model="searchForm.number" clearable/>
      </el-form-item>

      <el-form-item :label="$t('营养元素名称')">
        <el-input :placeholder="$t('营养元素名称')" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column prop="number" :label="$t('标识')"/>
        <el-table-column prop="name" :label="$t('对应营养元素')"/>
        <el-table-column prop="createTime" :label="$t('创建时间')">
          <template v-slot="{row}">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="60">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="openDialog(row)">{{
                  $t('编辑')
                }}
              </el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
        <template #title>
          <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
        </template>
        <el-form label-width="auto" label-position="left" ref="form" :model="dialogFormData" :rules="rules">
          <el-form-item :label="$t('营养元素名称')" prop="name">
            <el-input v-model="dialogFormData.name" :placeholder="$t('请输入元素名称')"/>
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleConfirm">{{ $t('确定') }}</el-button>
          <el-button @click="resetForm">{{ $t('重置') }}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "ElFlagList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      tabCurrent: "toAudit",
      dialogFormData: {},
      showDialog: false,
      rules: {
        name: {required: true, message: this.$t('请输入元素名称'), trigger: 'blur'},
      },

      curRow: {}
    }
  },
  methods: {
    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.elFlag.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    // 打开弹窗
    openDialog(row) {
      this.dialogFormData = row ? {...row} : {};
      this.showDialog = true;
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        const action = this.isEdit ? this.$api.elFlag.update : this.$api.elFlag.add;
        await request(action, this.dialogFormData);
        this.$message.success(this.$t('操作成功'));
        this.showDialog = false;
        this.$refs.list.handleRequest();
      })
    }
  },
  computed: {
    isEdit() {
      return Object.keys(this.dialogFormData).length > 0 && this.dialogFormData?.code;
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}
</style>
